import { getFullAddress } from "@delibrandev/utils";
import { useSelector } from "react-redux";
export const Details = () => {
  const data =
    useSelector((state) => state.aplicationConfig.userConfig.floatPanel.data) ||
    {};
  const addresses = data.addresses || {};
  return (
    <div className="clientContactCard">
      <dl>
        {[
          ["Nombre / Razón social", data.fullname],
          [
            "Correo electrónico",
            data.email ? (
              <a href={`mailto:${data.email}`}>{data.email}</a>
            ) : null,
          ],
          [
            "Teléfono",
            data.phone ? <a href={`tel:${data.phone}`}>{data.phone}</a> : null,
          ],
          ["NIF", data.nif],
        ].map(([label, value]) => (
          <div key={label}>
            <dt>{label}</dt>
            <dd>{value || "No indicado"}</dd>
          </div>
        ))}
      </dl>
      {[
        [
          "Direcciones de envío",
          addresses.shippingAddresses || addresses.addresses,
        ],
        [
          "Direcciones de facturación",
          addresses.billingAddresses || addresses.legalAddresses,
        ],
      ].map(([label, list]) => (
        <section key={label}>
          <h4>{label}</h4>
          {list?.length ? (
            list.map((address, index) => (
              <article className="clientAddressCard" key={address.id || index}>
                <strong>{address.name || "Dirección"}</strong>
                <p>{getFullAddress(address)}</p>
              </article>
            ))
          ) : (
            <p>No hay direcciones guardadas.</p>
          )}
        </section>
      ))}
    </div>
  );
};
